<template>

  <div class="login_block renew2_flex" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="login_block__01">
      <div class="login_mail">
        <h3>메일 주소로 등록</h3>
        <div class="renew2_flex id">
          <p class="title">로그인ID</p>
          <div class="input">
            <el-input v-model="mailRegister.email" type="email" autocomplete name="mail-link-input"
              placeholder="메일주소를 입력하세요" :disabled="loginEmailSending"></el-input>
          </div>
        </div>
        <div class="renew2_flex pw">
          <p class="title">패스워드</p>
          <div>
            <div class="input"><el-input v-model="mailRegister.passwd" type="password" autocomplete
                name="mail-link-input" placeholder="패스워드를 입력하세요" :disabled="loginEmailSending"></el-input></div>
          </div>
        </div>
        <div class="renew2_flex pw">
          <p class="title">확인용 패스워드</p>
          <div>
            <div class="input"><el-input v-model="mailRegister.passwdConfirm" type="password" autocomplete
                name="mail-link-input" placeholder="확인용 패스워드를 입력하세요." :disabled="loginEmailSending"></el-input></div>
          </div>
        </div>
        <p class="pw_memo">※영문소문자,대문자,숫자를 조합하여 8~20자로 입력해 주세요.기호도 사용할 수 있습니다.</p>
        <button type="button" class="btn" id="email-login-account-dialog"
          @click="registerIdPw()"><!----><!----><span>전송</span></button>
        <p class="memo">메일 주소 입력 후 확인메일 보내드리겠습니다.</p>
      </div>
    </div>
    <div class="login_block__02">
      <div class="login_sns">
        <h3>다른 서비스 ID를 이용하여<br class="renew2_sp">등록하기</h3>
        <ul class="renew2_flex sns_list">
          <li class="sns_list__item">
            <button class="renew2_flex renew2_sp_flex" @click="$firebase.signInGoogle();">
              <img src="/kr/resume/static/renew2_img/google.png" alt="Google">
              <p>Google로 등록</p>
            </button>
          </li>
          <li class="sns_list__item">
            <button class="renew2_flex renew2_sp_flex" @click="$firebase.signInApple();">
              <img src="/kr/resume/static/renew2_img/appleinc.png" alt="Apple">
              <p>AppleID로 등록</p>
            </button>
          </li>
          <li class="sns_list__item" v-if="false">
            <button class="renew2_flex renew2_sp_flex" @click="$firebase.signInFacebook();">
              <img src="/kr/resume/static/renew2_img/facebook.png" alt="Facebook">
              <p>Facebook로 등록</p>
            </button>
          </li>
        </ul>

        <div class="sns_list__link">
          <h3>메일로 등록링크 발송</h3>
          <div class="renew2_flex maillink">
            <div class="input"><el-input v-model="mailRegister.email" type="email" autocomplete name="mail-link-input"
                placeholder="메일주소를 입력 해주세요" :disabled="loginEmailSending"></el-input></div>
          </div>
          <el-button type="primary" id="email-login-account-dialog" class="maillink-btn" :plain="isPlainButton"
            @click="mailSubmit" v-loading="loginEmailSending">메일로 링크 전송</el-button>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  props: {
    isPlainButton: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loginEmailSending: false,
      fullscreenLoading: false,
      mailRegister: {
        email: ''
      },
      mailRegisterRules: {
        email: [
          {
            required: true,
            message: '메일을 입력하세요',
            trigger: 'blur'
          },
          {
            required: true,
            type: 'email',
            message: '메일을 입력하세요',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    resetloginEmail: function () {
      this.mailRegister.email = ''
      this.loginEmailSending = false
      // this.$refs['mailRegisterForm'].resetFields()
    },
    mailSubmit: function () {
      const app = this
      // this.$refs['mailRegisterForm'].validate(async valid => {
      //   if (!valid) {
      //     return
      //   }
      app.$firebase.signInEmail(app.mailRegister.email)
      app.loginEmailSending = true
      // })
    },
    isInValidEmail: function (mailStr) {
      const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)
      return !reg.test(mailStr)
    },
    isValidPassword: function (password) {
      if (password.length >= 8 && password.length <= 20) {
        return false
      } else {
        return true
      }
      const reg = new RegExp(/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]{8,100}$/)
      return !reg.test(password)
    },
    registerIdPw: function () {
      if (this.isInValidEmail(this.mailRegister.email)) {
        this.$message({
          message: '로그인 메일 주소를 올바르게 입력해 주세요.',
          type: 'error'
        })
        return
      }
      if (this.isValidPassword(this.mailRegister.passwd)) {
        this.$message({
          message: '올바른 형식으로 암호를 입력하십시오.※영소문자, 대문자, 숫자를 조합하여 8~20자로 입력해 주십시오.기호도 사용할 수 있습니다.',
          type: 'error'
        })
        return
      }
      if (this.mailRegister.passwd != this.mailRegister.passwdConfirm) {
        this.$message({
          message: '비밀번호와 확인비밀번호가 일치하지 않습니다.',
          type: 'error'
        })
        return
      }
      this.$firebase.signOnEmailPasswd(this.mailRegister.email, this.mailRegister.passwd)
    }
  },
  mounted: function () {
    this.$eventHub.$on('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$on('sing-in-mail-failed', this.resetloginEmail)
  },
  destroyed: function () {
    this.$eventHub.$off('sing-in-mail-send', this.resetloginEmail)
    this.$eventHub.$off('sing-in-mail-failed', this.resetloginEmail)
  }
}
</script>
